var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglassClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_505_154181)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M0.5 1.5C0.5 0.671719 1.17172 0 2 0H17C17.8297 0 18.5 0.671719 18.5 1.5C18.5 2.32828 17.8297 3 17 3V3.51469C17 5.50313 16.2078 7.41094 14.8016 8.81719L11.6234 12L13.3063 13.6453C12.7906 14.7234 12.5 15.975 12.5 17.25C12.5 20.0391 13.8875 22.5047 16.0062 24H2C1.17172 24 0.5 23.3297 0.5 22.5C0.5 21.6703 1.17172 21 2 21V20.4844C2 18.4969 2.79031 16.5891 4.19656 15.1828L7.37656 12L4.19656 8.81719C2.79031 7.41094 2 5.50313 2 3.51469V3C1.17172 3 0.5 2.32828 0.5 1.5ZM5 3V3.51469C5 4.40531 5.2625 5.26875 5.70781 6H13.25C13.7375 5.26875 14 4.40531 14 3.51469V3H5Z",
    fill: "#6B747D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 17.25C14 13.5234 17.0234 10.5 20.75 10.5C24.4766 10.5 27.5 13.5234 27.5 17.25C27.5 20.9766 24.4766 24 20.75 24C17.0234 24 14 20.9766 14 17.25ZM21.4578 14.25C21.4578 13.8375 21.1625 13.5 20.7078 13.5C20.3375 13.5 19.9578 13.8375 19.9578 14.25V17.25C19.9578 17.6625 20.3375 18 20.7078 18H23C23.4125 18 23.75 17.6625 23.75 17.25C23.75 16.8375 23.4125 16.5 23 16.5H21.4578V14.25Z",
    fill: "#6B747D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_505_154181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglassClock);
export default __webpack_public_path__ + "static/media/hourglass-clock.b8f164444f1b7176115079b90f13742d.svg";
export { ForwardRef as ReactComponent };